export const salesRecords = [
  {
    id: "S20260410001",
    userId: "R001",
    userName: "张建国",
    phone: "13812345678",
    amount: 200.00,
    gasVolume: 66.67,
    payMethod: "微信支付",
    payTime: "2026-04-10 09:15:32",
    status: "成功",
    iotStatus: "已下发",
    invoiceCode: "INV20260410001",
    ticketNo: "T20260410001",
  },
  {
    id: "S20260408002",
    userId: "C001",
    userName: "老北京涮肉馆",
    phone: "13512345678",
    amount: 5000.00,
    gasVolume: 1250.0,
    payMethod: "银联",
    payTime: "2026-04-08 14:22:18",
    status: "成功",
    iotStatus: "已下发",
    invoiceCode: "INV20260408002",
    ticketNo: "T20260408002",
  },
  {
    id: "S20260405003",
    userId: "R002",
    userName: "李秀梅",
    phone: "13698765432",
    amount: 100.00,
    gasVolume: 33.33,
    payMethod: "支付宝",
    payTime: "2026-04-05 16:45:55",
    status: "成功",
    iotStatus: "已下发",
    invoiceCode: "INV20260405003",
    ticketNo: "T20260405003",
  },
  {
    id: "S20260403004",
    userId: "C002",
    userName: "北京华联超市",
    phone: "13612345678",
    amount: 20000.00,
    gasVolume: 4000.0,
    payMethod: "数字人民币",
    payTime: "2026-04-03 10:08:42",
    status: "成功",
    iotStatus: "已下发",
    invoiceCode: "INV20260403004",
    ticketNo: "T20260403004",
  },
  {
    id: "S20260401005",
    userId: "R003",
    userName: "王大明",
    phone: "15912345678",
    amount: 500.00,
    gasVolume: 166.67,
    payMethod: "微信支付",
    payTime: "2026-04-01 08:30:15",
    status: "成功",
    iotStatus: "已下发",
    invoiceCode: "INV20260401005",
    ticketNo: "T20260401005",
  },
  {
    id: "S20260328006",
    userId: "C003",
    userName: "北京燃气热力工程设计院",
    phone: "13712345678",
    amount: 50000.00,
    gasVolume: 8333.33,
    payMethod: "银联",
    payTime: "2026-03-28 15:20:38",
    status: "成功",
    iotStatus: "已下发",
    invoiceCode: "INV20260328006",
    ticketNo: "T20260328006",
  },
];

export const purchasePresets = [100, 200, 300, 500];

export const paymentMethods = [
  { id: "wechat", name: "微信支付", icon: "ri-wechat-pay-fill", color: "#07C160" },
  { id: "alipay", name: "支付宝", icon: "ri-alipay-fill", color: "#1677FF" },
  { id: "dcep", name: "数字人民币", icon: "ri-money-cny-circle-fill", color: "#E63946" },
  { id: "unionpay", name: "银联", icon: "ri-bank-card-fill", color: "#E60012" },
  { id: "other", name: "其他支付", icon: "ri-secure-payment-fill", color: "#6B7280" },
];
